import { createRequest } from "@hg/one-account"
import { type AxiosError, type InternalAxiosRequestConfig } from "axios"

export type RESP<T = null> = {
    statusCode?: number
    code: number
    msg?: string
    data: T
}

const handleRequest = async (config: InternalAxiosRequestConfig) => {
    document.body.classList.add("wait")
    return config
}

const handleRequestError = (error: AxiosError) => {
    document.body.classList.remove("wait")

    return {
        code: -1,
        msg: error.message ?? "请求错误",
    }
}

// createRequest 的响应拦截器已将 AxiosResponse 解包为 RESP body { code, data, msg }，
// 此处不再做 response.data 二次解包。
const handleResponse = (response: any) => {
    document.body.classList.remove("wait")

    if (response?.code !== undefined) {
        response.msg = response.message ?? response.msg
    }
    return response
}

const handleResponseError = (error: AxiosError) => {
    document.body.classList.remove("wait")

    if (error.response?.status && error.response?.status >= 500) {
        return {
            code: -1,
            msg: "网络错误",
        }
    }

    const resData = error.response?.data as {
        code?: number
        statusCode?: number
        msg?: string
        message?: string
    }
    if (resData) {
        return {
            code: resData.code ?? resData.statusCode,
            msg: resData.message ?? resData.msg,
        }
    }

    return {
        code: -1,
        msg: error.response?.statusText ?? error.message ?? "请求错误",
    }
}

export const basicRequest = createRequest({
    requestOption: {
        baseURL: __REQUEST_HOST,
        responseType: "json",
        timeout: 5000,
        withCredentials: true,
    },
})
basicRequest.interceptors.request.use(handleRequest, handleRequestError)
basicRequest.interceptors.response.use(handleResponse, handleResponseError)

export const actRequest = createRequest({
    requestOption: {
        baseURL: __ACT_SERVER_HOST,
        responseType: "json",
        timeout: 5000,
        withCredentials: true,
    },
})
actRequest.interceptors.request.use(handleRequest, handleRequestError)
actRequest.interceptors.response.use(handleResponse, handleResponseError)
